import React, { Component } from "react";
import { connect } from "react-redux";

import { generateInput } from "../utils/misc";
import { filterMessages, startFiltering, endFiltering } from "../../store/messages";
import { starChannel } from "../../store/channels";

import { Header, Segment, Icon } from "semantic-ui-react";

import Form from "../utils/Form";

class MessagesHeader extends Component {
    state = { isChannelStarred: false };

    fields = () => [
        generateInput({
            name: "search",
            placeholder: "search messages",
            icon: "fas fa-search",
            disabled: !this.props.channels.currentChannel,
            formNoValidate: true,
        }),
    ];

    static getDerivedStateFromProps(props) {
        const { starredChannels, currentChannel } = props.channels;

        if (starredChannels.some(({ id }) => id === currentChannel?.id)) return { isChannelStarred: true };

        return { isChannelStarred: false };
    }

    onSubmit = async formValues => {
        const { channels, messages, filterMessages, startFiltering, endFiltering } = this.props;

        if (!channels.currentChannel) return;

        formValues.search ? startFiltering() : endFiltering();

        const filteredMessages = messages.messages.filter(
            ({ message, user: { name } }) =>
                message?.toLowerCase().includes(formValues.search?.toLowerCase()) ||
                name?.toLowerCase()?.includes(formValues.search?.toLowerCase()),
        );

        filterMessages(filteredMessages);
    };

    onStarChannel = () => {
        this.setState({ isChannelStarred: !this.state.isChannelStarred });

        this.props.starChannel(this.state.isChannelStarred ? "starred" : "star", this.props.channels.currentChannel);
    };

    render() {
        const { isChannelStarred } = this.state;
        const { channels, messages } = this.props;

        const { length: usersCount } = [...new Set(messages.messages.map(({ user: { name } }) => name))];

        return (
            <Segment clearing className="messages-header">
                <Header as="h2" style={{ margin: 0 }}>
                    {channels.currentChannel ? (
                        <>
                            {channels.isPrivateChannel ? (
                                <span>
                                    <span className="channel-name">@{channels.currentChannel?.channelName}</span>
                                </span>
                            ) : (
                                <>
                                    <span>
                                        <span className="channel-name">#{channels.currentChannel?.channelName}</span>
                                        <Icon
                                            name={isChannelStarred ? "star" : "star outline"}
                                            color={isChannelStarred ? "yellow" : "black"}
                                            onClick={this.onStarChannel}
                                        />
                                    </span>

                                    <Header.Subheader>
                                        {`${usersCount} ${usersCount > 1 ? "users" : "user"}`}
                                    </Header.Subheader>
                                </>
                            )}
                        </>
                    ) : (
                        "No Channel Selected"
                    )}
                </Header>

                <Header style={{ margin: 0 }}>
                    <div className="form-container">
                        <div className="form-wrapper">
                            <Form
                                form="searchMessages"
                                fields={this.fields()}
                                onSubmit={this.onSubmit}
                                onChange={this.onSubmit}
                            />
                        </div>
                    </div>
                </Header>
            </Segment>
        );
    }
}

export default connect(null, { filterMessages, startFiltering, endFiltering, starChannel })(MessagesHeader);
